export default __webpack_public_path__ + "static/6737-91beb4328f951de5771a61a67e38dcea.jpg";